/*
 * @Description:
 * @Date: 2020-07-05 22:58:32
 */

import { projectV2 } from '@/api/ajax';
import { mapState } from 'vuex';
export const judge = {
  computed: {
    ...mapState({
      projectId: state => state.homeProject.id,
      judgeType: state => state.homeProject.type,
      judgeProjectType: state => state.homeProject.projectType
    })
  },
  data() {
    return {
      judgeData: ''
    };
  },
  methods: {
    async jumpToEdit() {
      if (!['/edit/index', '/edit/index-next'].includes(this.$route.path)) {
        await this.$store.dispatch('syncProjectInfo', { id, projectType }); // 解决拦截跳转回编辑项目后，编辑项目数据未刷新
        const { id, projectType } = this.$route.query;
        this.$router.push({
          path: '/edit/index',
          query: {
            id,
            projectType
          }
        });
      }
    }
  },
  async created() {
    // {
    //   projectStatus //项目状态  0 乙方待编辑  1  乙方编辑完成   2 甲方待确认   3 甲方编辑完成
    //   auditStatus //审核状态  0 未提交审核  1 审核中  2 审核未通过  3  审核通过
    // }
    const {
      data: {
        data: { projectStatus, auditStatus, industryEnterpriseId }
      }
    } = await projectV2.judgeProjectAudit({
      id: this.projectId,
      type: this.judgeType
    });
    // 根据审核阶段 和 审核状态计算乙方应该显示的审核状态
    let realStatus = +auditStatus;

    if ([1, 2].includes(+projectStatus) && auditStatus == 3) {
      // 审核阶段没有到甲方编辑完成，但是审核状态已经是审核通过的情况
      // 理论上不会出现这类的数据
      // 强行把状态修改为审核中
      realStatus = 1;
    }
    if (projectStatus == 2) {
      // 甲方待确认，乙方始终为审核中状态
      realStatus = 1;
    }
    if (projectStatus == 3 && auditStatus != 3) {
      // 甲方已确认，但oss未审核或者审核未通过，乙方始终为审核中状态
      realStatus = 1;
    }

    this.judgeData = realStatus;
    // 非【编辑项目】不需要弹窗
    if (
      realStatus !== 3 &&
      !['/edit/index', '/edit/index-next'].includes(this.$route.path)
    ) {
      this.jumpToEdit();
      return;
    }

    if (realStatus === 1) {
      this.$alert(
        industryEnterpriseId > -1
          ? '<p style="color:#4a4a4a;font-size:16px;line-height:28px;"><span>请耐心等待运营后台进行审核，最新审核状态将显示在：</span><b>项目-“编辑项目”</b>处，审核通过且甲方确认项目信息无误后您将可以继续操作。</p>'
          : '<p style="color:#4a4a4a;font-size:16px;line-height:28px;"><span>请耐心等待运营后台进行审核，最新审核状态将显示在：</span><b>项目-“编辑项目”</b>处，审核通过后您将可以继续操作。</p>',
        '提示',
        {
          dangerouslyUseHTMLString: true
        }
      ).finally(() => {
        this.jumpToEdit();
      });
    } else if ([0, 2].includes(realStatus)) {
      let content =
        '<p style="color:#4a4a4a;font-size:16px;line-height:28px;"><span>请先完成：</span><b>“编辑项目”</b>中的相关信息</p>';
      if ([5, 7].includes(this.judgeProjectType) && realStatus === 2) {
        content =
          '<p style="color:#4a4a4a;font-size:16px;line-height:28px;"><span>请先完成：</span><b>“编辑项目”</b>中的相关信息<br /><b>请继续编辑项目信息或调研问卷的选项</b></p>';
      }
      this.$alert(content, '提示', {
        dangerouslyUseHTMLString: true
      })
        .then(res => {
          this.jumpToEdit();
        })
        .catch(action => {
          this.jumpToEdit();
        });
    }
  }
};
